import Values from './Values.jsx';

export default Values;
